export default __webpack_public_path__ + "static/media/trip_collage.42407362.png";